import React from "react";
import Modal from "../../../components/modal";

const CustomerDetailModal = ({ show, onClose, heading, initialData = {} }) => {
    const customer = initialData?.customer;

    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            {customer ? (
                <div className="row p-3">
                    <div className="col-md-6 mb-2">
                        <h5><strong>Name:</strong> {customer.name}</h5>
                    </div>
                    <div className="col-md-6 mb-2">
                        <h5><strong>Company Name:</strong> {customer.company_name}</h5>
                    </div>
                    <div className="col-md-6  mb-2">
                         <h5><strong>Phone:</strong> {customer.phone} </h5>
                    </div>
                    <div className="col-md-6 mb-2">
                         <h5><strong>Email:</strong> {customer.email} </h5>
                    </div>
                    <div className="col-md-6  mb-2">
                         <h5><strong>Created At:</strong> {new Date(customer.createdAt).toLocaleString()} </h5>
                    </div>
                    <div className="mb-2">
                         <h5><strong>Address:</strong> {customer.address} </h5>
                    </div>
                </div>
            ) : (
                <p>No customer details available</p>
            )}
        </Modal>
    );
};

export default CustomerDetailModal;
